import styled from "styled-components";
import "../../../../styles/variables.css";
import Flex from "../../../Flex";

export const FaqContainer = styled.div`
  width: 100%;
  height: 600px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  position: relative;
  @media (max-width: 600px) {
    width: 100%;
    height: 100%;
  }
`;

export const FaqInformation = styled.div`
  text-align: center;
  span {
    font-size: var(--fs15);
    font-weight: 400;
  }
`;

export const FaqList = styled.div`
  margin-top: 40px;
  height: 250px;
  overflow-y: auto;
  -webkit-mask: linear-gradient(
      transparent 0px,
      rgb(255, 255, 255) 24px,
      rgb(255, 255, 255) calc(100% - 24px),
      transparent 100%
    ),
    linear-gradient(
      270deg,
      rgb(255, 255, 255) 0px,
      rgb(255, 255, 255) 20px,
      transparent 20px
    );
  @media (max-width: 600px) {
    height: calc(100vh - 450px);
    -webkit-mask: none;
    margin-top: 25px;
  }
`;

export const ContinueButtonWrapper = styled(Flex)`
  position: absolute;
  bottom: 35px;
`;
